import { Component, OnInit, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { WebhookLog, WebhookLogListFilters, WebhookProvider } from '../../core/models/api.models';

@Component({
  selector: 'app-webhook-logs',
  standalone: true,
  imports: [DatePipe, FormsModule, RouterLink],
  templateUrl: './webhook-logs.component.html',
  styleUrl: './webhook-logs.component.scss',
})
export class WebhookLogsComponent implements OnInit {
  private readonly api = inject(ApiService);

  readonly loading = signal(false);
  readonly error = signal<string | null>(null);
  readonly rows = signal<WebhookLog[]>([]);
  readonly page = signal(1);
  readonly limit = signal(20);
  readonly total = signal(0);

  provider: WebhookProvider = 'all';
  status = '';
  eventType = '';
  q = '';

  ngOnInit(): void {
    this.load();
  }

  private filters(page = this.page()): WebhookLogListFilters {
    return {
      page,
      limit: this.limit(),
      provider: this.provider,
      status: this.status || undefined,
      event_type: this.eventType.trim() || undefined,
      q: this.q.trim() || undefined,
    };
  }

  load(page = this.page()): void {
    this.loading.set(true);
    this.error.set(null);
    this.api.getWebhookLogs(this.filters(page)).subscribe({
      next: (data) => {
        this.rows.set(data.rows || []);
        this.page.set(data.page);
        this.limit.set(data.limit);
        this.total.set(data.total);
        this.loading.set(false);
      },
      error: (err: { message?: string }) => {
        this.error.set(err?.message || 'Failed to load webhook logs');
        this.loading.set(false);
      },
    });
  }

  applyFilters(): void {
    this.load(1);
  }

  clearFilters(): void {
    this.provider = 'all';
    this.status = '';
    this.eventType = '';
    this.q = '';
    this.load(1);
  }

  sourceLabel(source: string | null | undefined): string {
    if (source === 'api_logs') return 'HTTP access';
    if (source === 'webhook_logs') return 'Audit';
    if (source === 'kobble') return 'Kobble audit';
    return '';
  }

  totalPages(): number {
    return Math.max(1, Math.ceil(this.total() / this.limit()));
  }

  prev(): void {
    if (this.page() > 1) this.load(this.page() - 1);
  }

  next(): void {
    if (this.page() < this.totalPages()) this.load(this.page() + 1);
  }
}
